import createRoute    from '@widesk-ui/tools/createRoute';
import UserGroupModel from '@models/website/UserGroupModel';

const route = createRoute.splitView(
	'/configuration/user_groups',
	'website',
	'UserGroupSplitView',
	UserGroupModel.localize('plural'),
);
export default route;
